import { createSlice } from "@reduxjs/toolkit";

export interface UserState {
    email: string;
    first_name: string;
    isLoading: boolean;
    carti_premium: any;
    api_keys: any;
}

const initialState: UserState = {
    email: '',
    first_name: '',
    isLoading: true,
    carti_premium: null,
    api_keys: null,
}


export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state: any, action: any) => ({
            ...state,
            ...action.payload,
            isLoading: false,
        }),
        setUserLoading: (state: any) => ({
            ...state,
            isLoading: true,
        }),
        setUserLoaded: (state: any) => ({
            ...state,
            isLoading: false,
        }),
        registerUser: (state: any, action: any) => ({
            ...state,
            email: action.payload.email,
            first_name: action.payload.firstName,
            isLoading: false,
        }),
        logoutUser: () => ({ ...initialState, isLoading: false }),
    }
})

export const userActions = userSlice.actions;
export const userReducer = userSlice.reducer;